export type TMeasurementPointLike = { x: number; y: number; z: number };
export type TOffsetLike = { x: number; y: number; z: number };

/**
 * QU3DW-1379 (SC_QUICK-2063) — converts a measurement's points into the rows
 * shown in the coordinate table, subtracting the project offset per axis.
 */
export function measurementPointsToTableRows(
  points: TMeasurementPointLike[] | undefined,
  offset: TOffsetLike
) {
  return (points ?? []).map((data, index) => ({
    id: index,
    pointName: index + 1,
    x: data.x - offset.x,
    y: data.y - offset.y,
    z: data.z - offset.z,
  }));
}
